import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { setAlert } from "../store/slices/alertSlice";
import { searchUsers } from "../services/api";

const HODSelection = ({ data, onChange, disabled = false }) => {

  const dispatch = useDispatch();

  const [hodSearch, setHodSearch] = useState("");
  const [hodList, setHodList] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const dropdownRef = useRef(null);

  /* ---------------- SEARCH HOD ---------------- */
  const handleSearch = async (e) => {

    const text = e.target.value;
    setHodSearch(text);

    if (!text) {
      setShowDropdown(false);
      setHodList([]);
      return;
    }

    try {
      const res = await searchUsers(text);
      
      // 🔥 FILTER ONLY HOD ROLE
      const hodUsers = res.data.users.filter(u => u.role?.roleName === "Supervisor/HOD");

      setHodList(hodUsers);
      setShowDropdown(true);

    } catch (err) {
      dispatch(setAlert({ message: "Error loading HODs", type: "danger" }));
    }
  };

  /* ---------------- SELECT HOD ---------------- */
  const selectHod = (user) => {

    const selected = data.hodObjects || [];

    const exists = selected.find(u => u._id === user._id);

    let updated;

    if (exists) {
      updated = selected.filter(u => u._id !== user._id);
    } else {
      updated = [...selected, user];
    }

    onChange({
      ...data,
      hodIds: updated.map(u => u._id),   // ✅ backend
      hodObjects: updated               // ✅ UI
    });

    setHodSearch("");
    setShowDropdown(false);
  };

  /* ---------------- PRIMARY SELECT ---------------- */
  const handlePrimaryChange = (e) => {

    onChange({
      ...data,
      primaryHodId: e.target.value
    });
  };

  /* ---------------- CLOSE DROPDOWN ---------------- */
  useEffect(() => {

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };

  }, []);

  return (
    <div className="form-container compact">

      {/* ================= HOD SEARCH ================= */}
      <div className="form-row">
        <div className="form-control" ref={dropdownRef} style={{ position: "relative" }}>

          <label>Select HOD(s)</label>

          <input
            type="text"
            placeholder="Search HOD..."
            value={hodSearch}
            onChange={handleSearch}
            className="form-control"
            disabled={disabled}
          />

          {!disabled && showDropdown && hodList.length > 0 && (
            <div className="dropdown-list">

              {hodList.map(user => {

                const isSelected = data.hodObjects?.some(u => u._id === user._id);

                return (
                  <div
                    key={user._id}
                    className={`dropdown-item ${isSelected ? 'selected' : ''}`}
                    onClick={() => selectHod(user)}
                  >
                    {user.username}
                    {isSelected && <span style={{ float: "right" }}>✔</span>}
                  </div>
                );
              })}

            </div>
          )}

          {/* Selected HODs */}
          {data.hodObjects?.length > 0 && (
            <div className="mt-2">
              {data.hodObjects.map(u => (
                <span
                  key={u._id}
                  className="badge bg-primary me-2"
                  style={{ cursor: disabled ? "default" : "pointer" }}
                  onClick={() => {
                    if (!disabled) selectHod(u);
                  }}
                >
                  {u.username} ✕
                </span>
              ))}
            </div>
          )}

        </div>
      </div>

      {/* ================= PRIMARY HOD ================= */}
      {data.hodObjects?.length > 0 && (
        <div className="form-row">
          <div className="form-control">

            <label>Primary HOD</label>

            <select
              value={data.primaryHodId || ""}
              onChange={handlePrimaryChange}
              disabled={disabled}
            >
              <option value="">Select Primary HOD</option>

              {data.hodObjects.map(u => (
                <option key={u._id} value={u._id}>
                  {u.username}
                </option>
              ))}

            </select>

          </div>
        </div>
      )}

    </div>
  );
};

export default HODSelection;

